<script>
    import { Router, Link, Route, link, navigate } from "svelte-routing";
    import Header from "../components/header.svelte"
    import CardRdv from "../components/cardRdv.svelte"
    import { isUserDbAdmin} from './stores.js';
    export var db;
    export var auth;
    export let location;
  location = location;

var user = auth.currentUser;
var is_Admin = false;

function goPanier(){
  navigate("/panier", { replace: false });
}
function goClients(){
  navigate("/clients", { replace: false });
}
function goListe(){
  navigate("/user", { replace: false });
}
function goJouets(){
  navigate("/jouets", { replace: false });
}



function logout(){
  auth.signOut().then(() => {
    user = undefined;
    navigate("/", { replace: false });
    window.location.reload()
}).catch((error) => {
  // An error happened.
});
}

var rdv;

var storedUser;

const unsubscribe = isUserDbAdmin.subscribe(value => {
		storedUser = value;
	});

auth.onAuthStateChanged(function(user) {
  if (user) {
    user = auth.currentUser
    console.log(user)

    db.collection("users").doc(user.uid).get().then((doc) => {
    if (doc.exists) {
        rdv = doc.data().rdv
    }
    })

    if(!storedUser){
          console.log("n'a pas été determiné si admin")
          db.collection("admins").doc(user.uid).get().then((doc) => {
            
            if (doc.exists) {
                  isUserDbAdmin.set({admin:true,name:doc.data().Nom});
                  is_Admin = true
              } else {
                  isUserDbAdmin.set({admin:false})
              }
          }).catch((error) => {
              console.log("Error getting document:", error);
          });;
        }
    if(storedUser.admin == true){
         is_Admin = true
       }


  } else {
    // No user is signed in.
  }
});

    var req = false
    var rdvs = []

    var rdv18 = [];
    var rdv19 = [];
    var rdv20 = [];
    var rdv09 = [];
    var rdv10 = [];
    var rdv11 = [];

    db.collection("rdv").orderBy("heure","asc")
    .get().then((querySnapshot) => {
        req = false
        rdvs = [];
        querySnapshot.forEach((doc) => {
            var temp = doc.data();
            temp.id = doc.id;
            rdvs.push(temp);
        });
        jeSlice(rdvs)
        req = true
    });

    function jeSlice(arr){
        rdv18 = arr.splice(0,6);
        rdv19 = arr.splice(0,6);
        rdv20 = arr.splice(0,6);
        rdv09 = arr.splice(0,6);
        rdv10 = arr.splice(0,6);
        rdv11 = arr.splice(0,6);
    }

    const decrement = firebase.firestore.FieldValue.increment(-1);



    var heureRdv = "";
    var tempRdv = {id:undefined,heurefinale:undefined};
    var maPopup;
  
    function validationRdv(event){
      tempRdv = event.detail
      maPopup.style.display = "flex";
    }


    function closePopup(){
      tempRdv = {};
      maPopup.style.display = "none";
    }

    function choixRdv(){
        heureRdv = tempRdv.heurefinale
        user = auth.currentUser
        //document.getElementById('modal_rdv').style.display = "block";
        db.collection('rdv').doc(tempRdv.id).update({
        place: decrement
        })
        .then(() => {
            db.collection('users').doc(user.uid).update({
            rdv: tempRdv.heurefinale
        })
        .then(() => {
             rdv = tempRdv.heurefinale
             closePopup()
        })
        })
    }

    function annuler(){
        heureRdv = "";
    }


</script>


<div class="blur" bind:this={maPopup}>
  <div class="popupValidation">
    <h1 style="color: teal;">Validation</h1>
    <h3>Vous êtes sur le point de valider l'heure suivante : {tempRdv.heurefinale != undefined ? tempRdv.heurefinale : ""}</h3>
    <div>
      <button class="valid" on:click={choixRdv}>Valider</button>
      <button class="cancel" on:click={closePopup}>Annuler</button>
    </div>
  </div>
</div>


<main>
    <div class="cache"></div>
    <Header>
        <div on:click={logout} class="elm">Déconnexion</div>
        <div class="elm" on:click={goListe}>Ma liste 📃</div>
        <div class="elm">RDV ⏰</div>
        {#if is_Admin}
        <div class="elm" on:click={goJouets}>Articles 🧸</div>
        <div class="elm" on:click={goClients}>Vendeurs 👱‍♂️</div>
        <div class="elm" on:click={goPanier}>Panier 🛒</div>
        {/if}
      </Header>
      {#if req}
      {#if !rdv}
      <div class="info">• Vous n'avez pas encore choisi d'heure de rendez-vous pour la dépose <br>
                        • Attention, dès lors que vous choisissez une heure, elle est définitive.
    </div>
      <div class="largecontain">
        <div class="daycontain">
            <div class="day">Vendredi</div>
            <div class="heures">
              <div class="heure">
                  
                  {#each rdv18 as rdv }
                    <CardRdv {rdv} on:setrdv={validationRdv}></CardRdv>  
                  {/each}
              </div>
              <div class="heure">
                  
                  {#each rdv19 as rdv }
                  <CardRdv {rdv} on:setrdv={validationRdv}></CardRdv>    
                  {/each}
              </div>
              <div class="heure">
                  
                  {#each rdv20 as rdv }
                  <CardRdv {rdv} on:setrdv={validationRdv}></CardRdv>   
                  {/each}
              </div>
            </div>
        </div>
        <div class="daycontain">
          <div class="day">Samedi</div>
          <div class="heures">
              <div class="heure">
                  
                  {#each rdv09 as rdv }
                    <CardRdv {rdv} on:setrdv={validationRdv}></CardRdv>    
                   {/each}
              </div>
              <div class="heure">
                  
                  {#each rdv10 as rdv }
                    <CardRdv {rdv} on:setrdv={validationRdv}></CardRdv>    
                  {/each}
              </div>
              <div class="heure">
                  
                  {#each rdv11 as rdv }
                    <CardRdv {rdv} on:setrdv={validationRdv}></CardRdv>    
                  {/each}
              </div>
          </div>
        </div>
    </div>
    <div class="modal" id="modal_rdv">
        <button class="valid" on:click={()=>console.log('valider',heureRdv)}>Valider</button>
        <button class="cancel" on:click={annuler}>Annuler</button>
    </div>
      {:else}
      <div class="rdvFixed">
        <div class="info">Votre heure de rendez-vous est :</div>
        <div class="info" style="font-size:5rem ;"><b>{rdv}</b></div>
        <div class="info" style="color: rgba(255,255,255,0.65); padding-top:10vh">Vous pouvez continuer de remplir votre liste si vous le souhaitez, puis la finaliser.</div>
      </div>
      {/if}
      {/if}
      
</main>

<style>
    main{
        background-color: #262626;
        width: 100vw;
        height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: white;
    }
    .elm{ 
        color: white;
        margin-right: 20px;
        cursor: pointer;
        font-weight: 700;
    }

    .elm:hover{
        color: #507DBC ;
        text-decoration: none;
    }
    .cache{
      width: 100vw;
      min-height: 15vh;
    }
    .info{
        height: 10vh;
        font-family: 'Poppins', sans-serif;
        font-weight: 400;
        font-size: clamp(.5rem, -0.875rem + 2vw, 3.5rem);
    }
    .largecontain{
        display: flex;
        width: 100vw;
        min-height: 75vh;
    }
    .daycontain{
        display: flex;
        flex-direction: column;
        width: 50%;
        height: fit-content;
        align-items: center;
    }
    .day{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: 'Poppins', sans-serif;
        font-weight: 700;
        margin: 3vh;
        font-size: 2rem;
        text-decoration: underline;
    }

    .heures{
        display: flex;
        flex-direction: row;
        width: 100%;
        height: fit-content;
        align-items: center;
        justify-content: center;
    }
    .heure{
        margin: 15px;
        height: fit-content;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .modal{
        display: none;
        position: fixed;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(10,10,10,0.99);
    }

    .valid{
        background-color: lightgreen;
        box-shadow: 0px 0px 30px -10px lightgreen;
        border-radius: 15px;
        font-family: 'Poppins', sans-serif;
        font-weight: 400;
        font-size: 2rem;
        margin: 15px;
        padding: 7px;
        border: none;
        cursor: pointer;
        color: #000;
    }
    .cancel{
        background-color: #f08080;
        box-shadow: 0px 0px 30px -10px lightcoral;
        border-radius: 15px;
        font-family: 'Poppins', sans-serif;
        font-weight: 400;
        font-size: 1.3rem;
        margin: 15px;
        padding: 7px;
        border: none;
        cursor: pointer;
        color: #000;
    }
    .valid:hover{
        transform: scale(1.025);
    }
    .cancel:hover{
        transform: scale(1.025);
    }


    .rdvFixed{
      margin-top: 20vh;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding-right: 10vw;
    }

    .blur{
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      background-color: rgba(10,10,10,0.89);
      display: none;
      align-items: center;
      justify-content: center;
    }

    .popupValidation{
      background-color: white;
      border-radius: 20px;
      padding: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
</style>